import React from 'react';
import { formatBps } from '../lib/routerMonitoringFormatters';

const RouterInterfaceTable = ({ rows = [], isLoading }) => (
  <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="text-sm font-semibold uppercase tracking-[0.12em] text-cyan-200">Interface</h3>
    {isLoading ? <p className="mt-2 text-sm text-slate-400">Memuat interface...</p> : null}
    {!isLoading && rows.length === 0 ? <p className="mt-2 text-sm text-slate-500">Belum ada data interface.</p> : null}
    {rows.length > 0 ? (
      <div className="mt-3 overflow-x-auto">
        <table className="min-w-full text-xs text-slate-200">
          <thead>
            <tr className="border-b border-slate-700 text-slate-400">
              <th className="px-2 py-2 text-left">Interface</th>
              <th className="px-2 py-2 text-left">Type</th>
              <th className="px-2 py-2 text-left">Status</th>
              <th className="px-2 py-2 text-right">In</th>
              <th className="px-2 py-2 text-right">Out</th>
              <th className="px-2 py-2 text-left">Role</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item) => (
              <tr key={item.name} className="border-b border-slate-800/70">
                <td className="px-2 py-2">{item.name}</td>
                <td className="px-2 py-2">{item.type || '-'}</td>
                <td className="px-2 py-2">
                  {item.running ? 'running' : 'down'} / {item.enabled === false ? 'disabled' : 'enabled'} / {item.sample_status || '-'}
                </td>
                <td className="px-2 py-2 text-right">{formatBps(item.in_bps)}</td>
                <td className="px-2 py-2 text-right">{formatBps(item.out_bps)}</td>
                <td className="px-2 py-2">
                  <div className="flex flex-wrap gap-1">
                    {item.is_primary ? <span className="rounded border border-amber-400/40 bg-amber-500/10 px-1.5 py-0.5 text-[10px] text-amber-200">Primary</span> : null}
                    {item.is_monitored ? <span className="rounded border border-cyan-400/40 bg-cyan-500/10 px-1.5 py-0.5 text-[10px] text-cyan-200">Monitored</span> : null}
                    {item.is_recommended ? <span className="rounded border border-emerald-400/40 bg-emerald-500/10 px-1.5 py-0.5 text-[10px] text-emerald-200">Recommended</span> : null}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : null}
  </div>
);

export default RouterInterfaceTable;
